// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YVxi9","col":"styles_col__1qpBJ"};